/**
 *工具类
 */
import Axios from 'axios'
const server = 'https://m.new-exhibit.com/api/'
// const server = 'http://localhost:14225/api/'
// const chalk = require('chalk')
import request from './request'
import qs from 'qs'
export default {
  /**
   * 保存数据
   */
  postData(url, data) {
    url = server + url
    // console.log(chalk.green(`> 请求方式 post  ${url}`))
    return request({
      url: url,
      method: "post",
      data: qs.stringify(data)
    })
  },
  getData(url, data) {
    return request({
      url: server + url,
      method: "get",
      params: data
    })
  },
  postJson(url, data) {
    url = server + url
    Axios.defaults.headers.post["Content-Type"] = "application/json";
    Axios.defaults.withCredentials = true
    return Axios.post(url, data).then(res => {
      return new Promise(function (resolve, reject) {
        if (res.data.code === "-1000") {
          // store.dispatch('user/resetToken').then(() => {
          //   location.reload() // 为了重新实例化vue-router对象 避免bug
          // })
          reject('error')
        } else {
          resolve(res)
        }
      }).catch(error => {
        this.$Message.success('服务器异常，请联系管理员!');
        console.log(error)
      })
    })
  },


  postArr(url, data) { //传输数组
    url = server + url
    Axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
    Axios.defaults.withCredentials = true
    return Axios.post(url, qs.stringify(data)).then(res => {
      return new Promise(function (resolve, reject) {
        if (res.data.code === "-1000") {
          // store.dispatch('user/resetToken').then(() => {
          //   location.reload() // 为了重新实例化vue-router对象 避免bug
          // })
          reject('error')
        } else {
          resolve(res)
        }
      }).catch(error => {
        this.$Message.success('服务器异常，请联系管理员!');
        console.log(error)
      })
    })
  },
  exportData(url, data) { //导出文件
    url = server + url
    return request({
      url: url,
      method: 'get',
      params: data,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
  },


  exportPost(url, data) { //导出文件
    url = server + url
    return request({
      url: url,
      method: 'post',
      data: qs.stringify(data),
      responseType: 'blob'
    })
  },


  //下载execl
  exportExcel(res, name) {
    const blob = new Blob([res.data])
    const fileName = name + '.xlsx'
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href)
    document.body.removeChild(elink)
  },


  setCookie(name, value, days) {
    let d = new Date()
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days)
    window.document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString()
  },
  getCookie(name) {
    let v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  },
  delCookie(name) {
    this.set(name, '', -1)
  },
  dateFormatter(value) {
    let date = new Date(value)
    let Y = date.getFullYear()
    let m = date.getMonth() + 1
    let d = date.getDate()
    let H = date.getHours()
    let i = date.getMinutes()
    let s = date.getSeconds()
    if (m < 10) {
      m = '0' + m
    }
    if (d < 10) {
      d = '0' + d
    }
    if (H < 10) {
      H = '0' + H
    }
    if (i < 10) {
      i = '0' + i
    }
    if (s < 10) {
      s = '0' + s
    }
    let t = Y + '-' + m + '-' + d + ' ' + H + ':' + i + ':' + s
    return t
  },
  dateDay(value) {
    let date = new Date(value)
    let m = date.getMonth() + 1
    let d = date.getDate()
    let H = date.getHours()
    let i = date.getMinutes()
    let s = date.getSeconds()
    if (m < 10) {
      m = '0' + m
    }
    if (d < 10) {
      d = '0' + d
    }
    if (H < 10) {
      H = '0' + H
    }
    if (i < 10) {
      i = '0' + i
    }
    if (s < 10) {
      s = '0' + s
    }
    let t = m + '-' + d + ' ' + H + ':' + i + ':' + s
    return t
  },
  getLastMonthDay(date) {
    if (date === null) {
      date = new Date()
    } else {
      date = new Date(date)
    }
    let currentMonth = date.getMonth()
    let nextMonth = ++currentMonth
    let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
    let oneDay = 1000 * 60 * 60 * 24
    let lastDate = new Date(nextMonthFirstDay - oneDay)
    let year = lastDate.getFullYear()
    let month = lastDate.getMonth() + 1
    let day = lastDate.getDate()
    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }
    return year + '-' + month + '-' + day
  },
  dateFormat(value) {
    let date = new Date(value)
    let Y = date.getFullYear()
    let m = date.getMonth() + 1
    let d = date.getDate()
    let H = date.getHours()
    let i = date.getMinutes()
    let s = date.getSeconds()
    if (m < 10) {
      m = '0' + m
    }
    if (d < 10) {
      d = '0' + d
    }
    if (H < 10) {
      H = '0' + H
    }
    if (i < 10) {
      i = '0' + i
    }
    if (s < 10) {
      s = '0' + s
    }
    let t = Y + '-' + m + '-' + d
    return t
  },
  dateFormatMoth(value) {
    let date = new Date(value)
    let Y = date.getFullYear()
    let m = date.getMonth() + 1
    let d = date.getDate()
    let H = date.getHours()
    let i = date.getMinutes()
    let s = date.getSeconds()
    if (m < 10) {
      m = '0' + m
    }
    if (d < 10) {
      d = '0' + d
    }
    if (H < 10) {
      H = '0' + H
    }
    if (i < 10) {
      i = '0' + i
    }
    if (s < 10) {
      s = '0' + s
    }
    let t = Y + '-' + m
    return t
  },
  getMonday(type, dates) {
    let now = new Date()
    let nowTime = now.getTime()
    let day = now.getDay()
    let longTime = 24 * 60 * 60 * 1000
    let n = longTime * 7 * (dates || 0)
    let dd = ''
    if (type === 's') {
      dd = nowTime - (day - 1) * longTime + n
    }
    if (type === 'e') {
      dd = nowTime + (7 - day) * longTime + n
    }
    dd = new Date(dd)
    let y = dd.getFullYear()
    let m = dd.getMonth() + 1
    let d = dd.getDate()
    m = m < 10 ? '0' + m : m
    d = d < 10 ? '0' + d : d
    day = y + '-' + m + '-' + d
    return day
  },
  getMonth(type, months) {
    let d = new Date()
    let year = d.getFullYear()
    let month = d.getMonth() + 1
    if (Math.abs(months) > 12) {
      months = months % 12
    }
    if (months !== 0) {
      if (month + months > 12) {
        year++
        month = (month + months) % 12
      } else if (month + months < 1) {
        year--
        month = 12 + month + months
      } else {
        month = month + months
      }
    }
    month = month < 10 ? '0' + month : month
    // let date = d.getDate()
    let firstday = year + '-' + month + '-' + '01'
    let lastday = ''
    if (month === '01' || month === '03' || month === '05' || month === '07' || month === '08' || month === '10' || month === '12') {
      lastday = year + '-' + month + '-' + 31
    } else if (month === '02') {
      if ((year % 4 === 0 && year % 100 !== 0) || (year % 100 === 0 && year % 400 === 0)) {
        lastday = year + '-' + month + '-' + 29
      } else {
        lastday = year + '-' + month + '-' + 28
      }
    } else {
      lastday = year + '-' + month + '-' + 30
    }
    let day = ''
    if (type === 's') {
      day = firstday
    } else {
      day = lastday
    }
    return day
  },
  getUploadUrl(url) {
    if (url) {
      return server + url
    } else {
      return server + "/system/uploadExhibitionFile"
    }
  },
  getImpUrl(url) {
    if (url) {
      return server + url
    } else {
      return server + "/v4/carLbs/batchImportCarLbs"
    }


  },
  checkCooike(url, type, params) {
    return request({
      url: url,
      method: type,
      params: params
    })
  },
  getNow() {
    let date = new Date()
    let Y = date.getFullYear()
    let m = date.getMonth() + 1
    let d = date.getDate()
    let H = date.getHours()
    let i = date.getMinutes()
    let s = date.getSeconds()
    if (m < 10) {
      m = '0' + m
    }
    if (d < 10) {
      d = '0' + d
    }
    if (H < 10) {
      H = '0' + H
    }
    if (i < 10) {
      i = '0' + i
    }
    if (s < 10) {
      s = '0' + s
    }
    let t = Y + '-' + m + '-' + d + ' ' + H + ':' + i + ':' + s
    return t
  },
}
